// react
import { useEffect, useEffectEvent } from 'react';

// react-redux
import { useSelector } from 'react-redux';

// project constants
import { DEFAULT_REFRESH_TOKEN_INTERVAL } from 'constants/auth';

// project utils
import { recoverSession, refreshAccessToken } from 'services/auth/sessionRefresh';
import { isNativePlatform } from 'services/auth/platform';
import { onResumeOrReconnect } from 'services/appResume';

const refreshTokenInterval = Number(import.meta.env.VITE_APP_REFRESH_TOKEN_INTERVAL) || DEFAULT_REFRESH_TOKEN_INTERVAL;

const REFRESH_THRESHOLD_MINUTES = refreshTokenInterval / 60000 + 5;

export const AuthProvider = ({ children }) => {
  const hasUser = useSelector((state) => Object.keys(state.user?.data ?? {}).length > 0);

  const refreshIfExpiring = useEffectEvent(() => {
    void recoverSession().then(() => refreshAccessToken(REFRESH_THRESHOLD_MINUTES));
  });

  const revalidateSession = useEffectEvent(() => {
    void recoverSession().then(() => refreshAccessToken());
  });

  useEffect(() => {
    if (!hasUser) return undefined;

    refreshIfExpiring();

    const intervalId = setInterval(() => {
      refreshIfExpiring();
    }, refreshTokenInterval);

    return () => clearInterval(intervalId);
  }, [hasUser]);

  useEffect(() => {
    if (!hasUser || !isNativePlatform()) return undefined;

    return onResumeOrReconnect(() => {
      revalidateSession();
    });
  }, [hasUser]);

  return <>{children}</>;
};
